export const action = {
  code: {
    settings: {
      url: 'https://app.bluefaucet.com/' 
    }
  }
}